var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppointmentTypeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.902,
    height: 25.358,
    viewBox: "0 0 25.902 25.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#208ce1;stroke-width:1.5px;}.a{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678.404 -317.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M690.457,397.388H681.25a2.1,2.1,0,0,1-2.1-2.1V381.1a2.1,2.1,0,0,1,2.1-2.1h16.718a2.1,2.1,0,0,1,2.1,2.1v6.077",
    transform: "translate(0 -58.835)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.724,
    transform: "translate(684.109 317.483)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 5.724,
    transform: "translate(695.586 317.483)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 20.91,
    transform: "translate(679.154 326.685)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 5.738,
    transform: "translate(682.544 330.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H2.769",
    transform: "translate(682.544 334.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.964,
    cy: 5.964,
    r: 5.964,
    transform: "translate(691.626 330.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1097.273,691.553v3.684h3.111",
    transform: "translate(-399.899 -358.597)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentTypeIcon);
export default __webpack_public_path__ + "static/media/appointment_type_icon.527ce2d500de89d762fca5085aa1a5a1.svg";
export { ForwardRef as ReactComponent };